<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Bill Of Process" active>

                                <b-row v-if="hasFailedDataBillOfProcess">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedBillOfProcess.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfProcesssFailed" :fields="fieldsBillOfProcess" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfProcess" :sort-desc.sync="sortDescBillOfProcess" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedBillOfProcess.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfProcesss" :fields="fieldsBillOfProcess" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfProcess" :sort-desc.sync="sortDescBillOfProcess" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Bill Of Process Detail" active>

                                <b-row v-if="hasFailedDataBillOfProcessDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedBillOfProcessDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfProcessDetailsFailed" :fields="fieldsBillOfProcessDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfProcessDetail" :sort-desc.sync="sortDescBillOfProcessDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(sequence)="row">
													{{ Number(row.item.sequence).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedBillOfProcessDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfProcessDetails" :fields="fieldsBillOfProcessDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfProcessDetail" :sort-desc.sync="sortDescBillOfProcessDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(sequence)="row">
													{{ Number(row.item.sequence).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessList from '@/models/BillOfProcess/BillOfProcessList';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsBillOfProcess: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Bill Of Process Part Type", key: 'billOfProcessPartTypeCode', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partNumberPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Part Separate", key: 'partNumber.partNumber', sortable: false},
				{"class" : "th-status", "label" : "Part Separate Name", key: 'partNumber.partName', sortable: false},
				{"class" : "th-status", "label" : "NextProcess", key: 'nextProcessName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsBillOfProcessDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Sequence", key: 'sequence', sortable: false},
				{"class" : "th-status", "label" : "Machine", key: 'machineCode', sortable: false},
				{"class" : "th-status", "label" : "Sub Process", key: 'subProcessCode', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			billOfProcesss : [],
			billOfProcesssFailed: [],
			billOfProcessId : '',
			sortByBillOfProcess: '',
			sortDescBillOfProcess: '',
			hasFailedDataBillOfProcess: false,
			totalFailedBillOfProcess: 0,
			totalSucceedBillOfProcess: 0,
			billOfProcessDetails : [],
			billOfProcessDetailsFailed: [],
			billOfProcessDetailId : '',
			sortByBillOfProcessDetail: '',
			sortDescBillOfProcessDetail: '',
			hasFailedDataBillOfProcessDetail: false,
			totalFailedBillOfProcessDetail: 0,
			totalSucceedBillOfProcessDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('billofprocess/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('billofprocess/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getBillOfProcessForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getBillOfProcessForUpload : async function() {
			let _this = this;
			this.$http.get('billofprocess/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.billOfProcesss = [];
_this.billOfProcessDetails = [];


					if (response != null) {
						let result = response.data;
						_this.billOfProcesss = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedBillOfProcess = _this.billOfProcesss.length;

						_this.billOfProcesssFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataBillOfProcess = true;
						_this.totalFailedBillOfProcess = 0;
						if(_this.billOfProcesssFailed == undefined || _this.billOfProcesssFailed.length === 0) _this.hasFailedDataBillOfProcess = false;
						if(_this.hasFailedDataBillOfProcess) _this.totalFailedBillOfProcess = _this.billOfProcesssFailed.length;
						_this.billOfProcessDetails = [];
						_this.billOfProcessDetailsFailed = [];
						_this.totalFailedBillOfProcessDetail = 0;
						result.forEach(function(element) {
							_this.hasFailedDataBillOfProcessDetail = true;

							_this.billOfProcessDetails.push(...element.billOfProcessDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedBillOfProcessDetail = _this.billOfProcessDetails.length;

							_this.billOfProcessDetailsFailed.push(...element.billOfProcessDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.billOfProcessDetailsFailed == undefined || _this.billOfProcessDetailsFailed.length === 0) _this.hasFailedDataBillOfProcessDetail = false;
							if(_this.hasFailedDataBillOfProcessDetail) _this.totalFailedBillOfProcessDetail = _this.billOfProcessDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'billofprocess/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'BillOfProcess.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterBillOfProcess = new BillOfProcessFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
